import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Page imports
import GoodsInModule from './pages/goods-in/GoodsInModule';
// import OrderModule from './pages/order/OrderModule';
// import AnalyticsModule from './pages/analytics/AnalyticsModule';

// Placeholder components for modules not yet built
const OrderModule = () => (
  <div className="min-h-screen bg-slate-50 flex items-center justify-center">
    <div className="text-center">
      <div className="text-6xl mb-4">📦</div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">StockIQ Order</h1>
      <p className="text-gray-500">AI-powered ordering module coming soon...</p>
    </div>
  </div>
);

const AnalyticsModule = () => (
  <div className="min-h-screen bg-slate-50 flex items-center justify-center">
    <div className="text-center">
      <div className="text-6xl mb-4">📊</div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Branch Analytics</h1>
      <p className="text-gray-500">Analytics module coming soon...</p>
    </div>
  </div>
);

// Dashboard/Home
const BranchDashboard = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-6">
    <header className="max-w-4xl mx-auto mb-8">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-lg shadow-emerald-500/25">
          <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="w-7 h-7">
            <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">StockIQ Branch</h1>
          <p className="text-gray-500">Birmingham Central Pharmacy</p>
        </div>
      </div>
    </header>
    
    <main className="max-w-4xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <a href="/order" className="group bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-lg hover:-translate-y-1 transition-all">
          <div className="w-14 h-14 rounded-xl bg-blue-50 flex items-center justify-center mb-4 group-hover:bg-blue-100 transition-colors">
            <svg viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" className="w-7 h-7">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="text-lg font-bold text-gray-900 mb-1">Order</h2>
          <p className="text-sm text-gray-500">AI-suggested ordering with smart quantities</p>
        </a>
        
        <a href="/goods-in" className="group bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-lg hover:-translate-y-1 transition-all">
          <div className="w-14 h-14 rounded-xl bg-emerald-50 flex items-center justify-center mb-4 group-hover:bg-emerald-100 transition-colors">
            <svg viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" className="w-7 h-7">
              <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="text-lg font-bold text-gray-900 mb-1">Goods-In</h2>
          <p className="text-sm text-gray-500">Scan deliveries, verify stock, raise claims</p>
        </a>
        
        <a href="/analytics" className="group bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-lg hover:-translate-y-1 transition-all">
          <div className="w-14 h-14 rounded-xl bg-purple-50 flex items-center justify-center mb-4 group-hover:bg-purple-100 transition-colors">
            <svg viewBox="0 0 24 24" fill="none" stroke="#7c3aed" strokeWidth="2" className="w-7 h-7">
              <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="text-lg font-bold text-gray-900 mb-1">Analytics</h2>
          <p className="text-sm text-gray-500">Branch performance and insights</p>
        </a>
      </div>
    </main>
  </div>
);

function App() {
  return (
    <Routes>
      <Route path="/" element={<BranchDashboard />} />
      <Route path="/order/*" element={<OrderModule />} />
      <Route path="/goods-in/*" element={<GoodsInModule />} />
      <Route path="/analytics/*" element={<AnalyticsModule />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
